import React, { useState } from 'react'
import { Box, Divider, TextField } from '@mui/material'
import { Button, makeStyles } from '@material-ui/core'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import { useDispatch, useSelector } from 'react-redux'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { updateCurrentPolicyDetailsMotor } from 'src/actions'
import { USERIDV } from 'src/utils/constants/BuyPolicy'

const IDVCoverTile = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const [idvValue, setIdvValue] = useState(
    motorDetails?.currentPolicyDetails?.idv
      ? motorDetails?.currentPolicyDetails?.idv
      : motorDetails?.currentPolicyDetails?.idvMaxValue
  )
  const [userIdv, setUserIdv] = useState('')
  const [isUserIdv, setIsUserIdv] = useState(false)
  const handleSelect = (value, name) => {
    if (name === USERIDV) {
      setIsUserIdv(false)
      setIdvValue(userIdv)
    } else {
      setIsUserIdv(true)
      setIdvValue(value)
    }
  }
  const handleSetIDV = () => {
    dispatch(
      updateCurrentPolicyDetailsMotor({
        ...motorDetails?.currentPolicyDetails,
        idv: idvValue,
      })
    )
  }

  return (
    <Box className={classes.idvCoverTileContainer}>
      <Box className={classes.idvCoverTileSection}>
        <Box className={classes.idvCoverTileHeadingSection}>
          <Box className={classes.idvCoverTileHeading}>Cover Value (IDV)</Box>
          <Box className={classes.idvCoverTileHeadingTag}>
            The maximum value you will receive in case of total damage or theft.
          </Box>
        </Box>
        <Box>
          <FormControl>
            <RadioGroup
              aria-labelledby='radio-buttons-group-label-idv'
              defaultValue='female'
              // name='radio-buttons-group-idv'
              value={idvValue}
              onChange={(event) => {
                handleSelect(event?.target?.value, event?.target?.name)
              }}
            >
              <FormControlLabel
                value={motorDetails?.currentPolicyDetails.idvMinValue}
                control={<Radio size='small' />}
                name='radio-buttons-group-idv'
                label={
                  <Box className={classes.idvRadioBtnText}>
                    Lowest (
                    {formatToINR(
                      motorDetails?.currentPolicyDetails?.idvMinValue ?? 0
                    )}
                    )
                  </Box>
                }
              />
              <Divider />
              <FormControlLabel
                value={motorDetails?.currentPolicyDetails.idvMaxValue}
                control={<Radio size='small' />}
                name='radio-buttons-group-idv-a'
                label={
                  <Box className={classes.idvRadioBtnText}>
                    Recommended (
                    {formatToINR(
                      motorDetails?.currentPolicyDetails?.idvMaxValue ?? 0
                    )}
                    )
                  </Box>
                }
              />
              <Divider />
              <FormControlLabel
                value={userIdv}
                control={<Radio size='small' />}
                name='usersIdv'
                label={
                  <Box>
                    <TextField
                      size='small'
                      placeholder='Set your own'
                      variant='outlined'
                      type='number'
                      onChange={(event) => setUserIdv(event?.target?.value)}
                      InputProps={{
                        className: classes.idvRadioBtnTextfield,
                      }}
                      disabled={isUserIdv}
                    />
                  </Box>
                }
              />
              <Box className={classes.idvRadioPriceContainer}>{`${formatToINR(
                motorDetails?.currentPolicyDetails?.idvMinValue ?? 0
              )} to ${formatToINR(
                motorDetails?.currentPolicyDetails?.idvMaxValue ?? 0
              )}`}</Box>
            </RadioGroup>
          </FormControl>
        </Box>
        <Box>
          <Button className={classes.idvCoverBtn} onClick={handleSetIDV}>
            Set this Value
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default IDVCoverTile

const useStyles = makeStyles({
  idvCoverTileContainer: {
    maxHeight: '310px',
    maxWidth: '261px',
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0px 0px 15px 0px #00000066',
  },
  idvCoverTileSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
    gap: 15,
  },
  idvCoverTileHeadingSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  idvCoverTileHeading: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '0em',
    color: '#000000',
  },
  idvCoverTileHeadingTag: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14.06px',
    letterSpacing: '0em',
    color: '#000000',
  },
  idvCoverBtn: {
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '14.06px',
    background: 'linear-gradient(87.86deg, #59ADCA -1.42%, #60B9E0 154.94%)',
    maxWidth: '131px',
    maxHeight: '35px',
  },
  idvRadioBtnText: {
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15.23px',
  },
  idvRadioBtnTextfield: {
    // border: '1px solid #B3B3B3',
    height: '27px ',
    maxWidth: '138px',
  },
  idvRadioPriceContainer: {
    display: 'flex',
    justifyContent: 'center',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
  },
})
